
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goi-dich-vu-goi-kham-suc-khoe-tong-quat",
      function () {
        return require("private-next-pages/goi-dich-vu-goi-kham-suc-khoe-tong-quat/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goi-dich-vu-goi-kham-suc-khoe-tong-quat"])
      });
    }
  